import { rudderVisitPage } from '@webapp/utils/rudderstack/init';

export async function parseLocation({
  path,
  name,
}: {
  path: string;
  name?: string;
}): Promise<void> {
  if (name) {
    await rudderVisitPage(name, { name: name, url: path });
  } else {
    const newName = path.split('/').slice(1).join(' ').trim();
    await rudderVisitPage(newName, { name: newName, url: path });
  }
}
